import React, { useRef } from "react";

import { useSelector } from "react-redux";

import { BaseTable } from "components/Importer/BaseTable";

import { selectPropertyEnrichedBusinessByBusinessIdLookup } from "selectors";

export function BusinessImporter({
  importBusinesses,
  columns,
  agrinousBusinessLookupSelector,
  lookupKey,
}) {
  const businessIdByKeyLookup = useSelector(agrinousBusinessLookupSelector);

  const businessByIdLookup = useSelector(
    selectPropertyEnrichedBusinessByBusinessIdLookup,
  );
  const agGridInstance = useRef();

  const onGridReady = params => {
    agGridInstance.current = params;
    const defaultSortModel = [
      { colId: "agrinousBusiness.name", sort: "asc", sortIndex: 0 },
      { colId: "businessName", sort: "asc", sortIndex: 1 },
    ];

    params.columnApi.applyColumnState({
      state: defaultSortModel,
    });
  };

  const businessData = React.useMemo(
    () =>
      importBusinesses.map(b => ({
        ...b,
        agrinousBusiness:
          businessByIdLookup[businessIdByKeyLookup[b[lookupKey]]],
      })),

    [businessIdByKeyLookup, businessByIdLookup, importBusinesses, lookupKey],
  );

  return (
    <BaseTable
      columns={columns}
      data={businessData}
      onGridReady={onGridReady}
    />
  );
}
